import { ComplianceDocumentType } from "src/utils/documentSeriesEnum";
import { defineForm, MANUAL_DOC_ENDPOINTS } from "../../../../core";
import { vendorPreserve } from "../../../_shared/preserve";
import { verifactuCreditNoteSchema } from "./schema";

export const verifactuCreditNoteConfig = defineForm({
  id: "verifactu_credit_note",
  createEndpoint: MANUAL_DOC_ENDPOINTS.VERIFACTU_CREDIT_NOTE,
  permission: "ManualDocumentsIN_Write",
  seriesPermission: "ManualDocumentsSeries_Read",
  documentClass: "CreditNote",
  accountClass: "AccountReceivable",
  taxRatesChannel: "VeriFactu",
  invoiceType: "creditNote",
  complianceType: ComplianceDocumentType.CreditNote,
  requiresLegalRep: true,
  titleKey: "CreditNote",
  complianceStandardKey: "verifactu",
  schema: verifactuCreditNoteSchema,
  preserveOnReset: vendorPreserve,
  sections: {
    customer: { hiddenFields: ["customerCompanyAddress"] },
  },
  hiddenSections: ["recurring"],
  omitFromPayload: ["customerCompanyAddress"],
});